// Imports
import { ConfigModule } from "./ConfigModule";
import { ItemsModule } from "./ItemsModule";

export default {
  ConfigModule,
  ItemsModule,
};
